window.AdminChart = {
  draw(element) {
    type = element.data('chart-type');
    data = element.data('chart-data');
    dataLabels = element.data('chart-data-labels');
    axisTicksLabels = element.data('chart-axis-ticks-labels');
    element.edgeCharts(type, data, dataLabels, axisTicksLabels);
  },
};
